import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-258" data-mp="2worl3y57a7g0">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-259" data-mp="2wqckc12gmek7">
        <SectionHeading title={<>
              👉 Do any of these <em className="not-italic text-gold-600" data-id="element-261" data-mp="35p7o76i17ckc">sound familiar?</em>
            </>} subtitle="If you answered YES to any of them, Occlusion 360™ was created for you." data-id="element-260" data-mp="2rowxq4kmvzzp" />

        <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-262" data-mp="3fg2bme70ki7d">
          {painPoints.map(point => <li key={point.text} className="flex h-full items-start gap-3.5 rounded-2xl border border-navy-900/10 bg-cream-100 p-4" data-id="element-263" data-mp="3afwi0sh6olmn">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-264" data-mp="3kem0amczs83f">
                {point.emoji}
              </span>
              <span className="text-[14.5px] leading-snug text-navy-800/90" data-id="element-265" data-mp="sv9qfvn1iucz">
                {point.text}
              </span>
            </li>)}
        </ul>

        <div className="mt-9 rounded-3xl border border-gold-500/40 bg-gold-100/60 p-6 text-center sm:p-8" data-id="element-266" data-mp="wy6e40rftgns">
          <p className="font-display text-[20px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-267" data-mp="16uj9r46jm4l6">
            And it shouldn’t have to feel this way.
          </p>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy-700/85" data-id="element-268" data-mp="1btdptyd4lf1l">
            Because the problem isn’t necessarily that you need to study more
            occlusion. The problem may be that you have the information…
          </p>
          <p className="mt-4 font-display text-[19px] font-bold text-gold-700 sm:text-2xl" data-id="element-269" data-mp="1plae1rbob4sp">
            but not a system for using it.
          </p>
          <p className="mx-auto mt-4 max-w-xl text-[15px] font-medium leading-relaxed text-navy-800" data-id="element-270" data-mp="1ui0sybbqrucj">
            Occlusion 360™ turns scattered concepts into a visual decision-making
            system.
          </p>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-271" data-mp="14w86am0wg8ql">
          <CTAButton label="I want a structured system" subline="Instant access · One-time payment of $27 USD" data-id="element-272" data-mp="14xsza77kfjmc" />
        </div>
      </div>
    </section>;
}